/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   optimizely event constants
 */

export const USER_ENGAGEMENT_CONTACT = 'USER_ENGAGEMENT_CONTACT'
export const USER_ENGAGEMENT_GENERAL = 'USER_ENGAGEMENT_GENERAL'
